module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-modal"
  }, [_c('div', {
    staticClass: "video-modal__overlay",
    on: {
      "click": _vm.closeVideo
    }
  }, [_c('div', {
    staticClass: "video-modal__container"
  }, [_c('div', {
    staticClass: "video-modal__close",
    on: {
      "click": _vm.closeVideo
    }
  }, [_c('span'), _c('span')]), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-modal__content"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube-nocookie.com/embed/d7btRdy8F-I?showinfo=0",
      "frameborder": "0",
      "allow": "autoplay; encrypted-media",
      "allowfullscreen": "allowfullscreen"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ec72734","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/video-modal/video-modal.pug
// module id = 716
// module chunks = 1